const STORAGE_KEY = 'orgShortAssessmentLinksEnabled';

let cachedEntityId: string | null = null;
let cachedShortLinksEnabled = false;

function readFromSessionStorage(entityId: string | null | undefined): boolean {
    if (!entityId || typeof sessionStorage === 'undefined') return false;
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        const parsed = JSON.parse(raw) as { entityId?: string; enabled?: boolean };
        if (parsed.entityId !== entityId) return false;
        return parsed.enabled === true;
    } catch {
        return false;
    }
}

/** Sync org short-link preference for copy-link utilities (non-React callers). */
export function syncOrgAssessmentLinkPreferences(
    entityId: string | null | undefined,
    shortLinksEnabled: boolean
): void {
    const id = entityId ? String(entityId) : null;
    cachedEntityId = id;
    cachedShortLinksEnabled = shortLinksEnabled;
    if (!id || typeof sessionStorage === 'undefined') return;
    try {
        sessionStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({ entityId: id, enabled: shortLinksEnabled })
        );
    } catch {
        // ignore quota / private mode
    }
}

export function getOrgShortAssessmentLinksEnabled(entityId?: string | null): boolean {
    const id = entityId ? String(entityId) : cachedEntityId;
    if (id && cachedEntityId === id) {
        return cachedShortLinksEnabled;
    }
    return readFromSessionStorage(id);
}

export function getCurrentEntityIdFromStorage(): string | null {
    try {
        const stored = JSON.parse(localStorage.getItem('user') || '{}');
        const user = stored?.user || {};
        const candidate = user.currentEntityId || user.entityId;
        return candidate ? String(candidate) : null;
    } catch {
        return null;
    }
}
